var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeaderTab',{attrs:{"title":_vm.$t('global.cards_dashboard'),"return_action":'navigationBack'}}),_c('div',{attrs:{"id":"content"}},[_c('shutter-panel',{ref:"shutterPanel"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }